(function () {
  function getEmbeddedProduct() {
    const el = document.querySelector('.appstle_stand_alone_price_display_selector[data-product-data]');
    if (!el) return null;
    try { return JSON.parse(el.getAttribute('data-product-data')); } catch { return null; }
  }

  function getSelectedVariantId() {
    const el = document.querySelector('form[data-product-form] select[name="id"], form[data-product-form] input[name="id"]');
    return el ? parseInt(el.value, 10) : null;
  }

  function getSelectedSellingPlanId() {
    const checked = document.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');
    return checked ? checked.value : null;
  }

  function findAtcPriceEl() {
    return document.querySelector('button.add-to-cart-btn [x-html*="totalCurrentPrice"]');
  }

  function moneyTextFromCents(cents) {
    const fmt = (window.Shopify && window.Shopify.money_format) ? window.Shopify.money_format : "£{{amount}}";
    const value = (cents / 100).toFixed(2);
    return fmt.replace("{{amount}}", value);
  }

  function getTargetPriceCents(product, variantId, sellingPlanId) {
    const variant = (product.variants || []).find(v => v.id === variantId) || (product.variants || [])[0];
    if (!variant) return null;
    if (!sellingPlanId) return variant.price;

    const alloc = (variant.selling_plan_allocations || []).find(a => String(a.selling_plan_id) === String(sellingPlanId));
    if (alloc && typeof alloc.price === "number") return alloc.price;

    return variant.price;
  }

  function refresh() {
    const product = getEmbeddedProduct();
    const priceEl = findAtcPriceEl();
    if (!product || !priceEl) return;

    const variantId = getSelectedVariantId();
    const sellingPlanId = getSelectedSellingPlanId();
    const cents = getTargetPriceCents(product, variantId, sellingPlanId);
    if (typeof cents !== "number") return;

    priceEl.innerHTML = moneyTextFromCents(cents);
  }

  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', refresh);
  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected', refresh);
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;
    if (t.name === "id" || (t.closest && t.closest('form[data-product-form]'))) refresh();
  });

  document.addEventListener('DOMContentLoaded', refresh);
})();
